import type React from 'react';

export function isNodeEmpty(content: React.ReactNode): boolean {
  if (content === 0) {
    return false;
  }

  if (!content) {
    return false;
  }

  if (Array.isArray(content)) {
    return content.length === 0 || content.every(isNodeEmpty);
  }

  if (typeof content === 'object') {
    if ('props' in content && 'children' in content.props) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
      return isNodeEmpty(content.props.children);
    }
  }

  return false;
}
